/**
 * Chuỗi UI — nguồn sự thật: `locales/messages.json` (có thể export/import CSV, xem package.json scripts).
 * Component dùng `useAppTranslation().t('key')`.
 */
import messages from '@/i18n/locales/messages.json';
import { DEFAULT_LOCALE_ID, normalizeLocale } from '@/i18n/localeCatalog';

export const dictionary = messages;

export function interpolate(template, vars) {
  if (!template || !vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] !== undefined && vars[key] !== null ? String(vars[key]) : `{${key}}`,
  );
}

export function translate(locale, key, vars) {
  const id = normalizeLocale(locale);
  const pack = dictionary[id] || dictionary[DEFAULT_LOCALE_ID];
  const fallback = dictionary[DEFAULT_LOCALE_ID];
  const raw = pack[key] ?? fallback[key] ?? key;
  return interpolate(raw, vars);
}
